var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-progress-linear',{attrs:{"value":_vm.progress,"color":_vm.inactive ? 'white' : 'primary',"height":"12","rounded":""}},[(_vm.inactive)?_c('strong',[_vm._v("--")]):_c('strong',{staticClass:"caption white--text"},[_vm._v(" "+_vm._s(Math.ceil(_vm.progress))+"% ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }